import { Actions, createEffect, ofType } from '@ngrx/effects';
import { logout, sessionExpired, sessionExpiredConfirmed } from './login.actions';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { AuthService } from '../../modules/shared/services/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { SessionExpiredModalComponent } from '../../modules/shared/session-expired-modal/session-expired-modal.component';
import { profileClearCache } from '../profile/profile.actions';
import { Store } from '@ngrx/store';
import { AppState } from '../index';

@Injectable()
export class LoginEffects {

    constructor(private actions$: Actions, private authService: AuthService,
                private dialog: MatDialog, private store: Store<AppState>) {
    }

    logout$ = createEffect(() => this.actions$.pipe(
        ofType(logout),
        tap(() => this.authService.redirectToLogout())
    ), { dispatch: false });

    sessionExpired$ = createEffect(() => this.actions$.pipe(
        ofType(sessionExpired),
        tap(() => {
            this.store.dispatch(profileClearCache());
            const ref = this.dialog.open(SessionExpiredModalComponent, { disableClose: true });
            ref.afterClosed().subscribe(() => {
                this.store.dispatch(sessionExpiredConfirmed());
            });
        })
    ), { dispatch: false });

    sessionExpiredConfirmed$ = createEffect(() => this.actions$.pipe(
        ofType(sessionExpiredConfirmed),
        tap(() => {
            this.authService.sessionExpiredInProgress = false;
            this.authService.redirectToLogin();
        })
    ), { dispatch: false });

}
